import { render, staticRenderFns } from "./choseDialog.vue?vue&type=template&id=460d1623&"
import script from "./choseDialog.vue?vue&type=script&lang=js&"
export * from "./choseDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports